import * as React from 'react';

import * as style from './ReviewsList.css';

export interface IReviewsListProps {
  children: React.ReactElement<any>[];
}

export const ReviewsList = (props: IReviewsListProps): React.JSX.Element => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
